import React from 'react'

type MenuButtonProps = {
    isOpen: boolean;
    onToggle: () => void;
    icon: React.ReactNode;
    label: string;
    disabled?: boolean;
}

const MenuButton = ({
    isOpen,
    onToggle,
    icon,
    label,
    disabled = false }: MenuButtonProps) => {
    return (
        <button
            className={`tw-pr-4 tw-pl-2 tw-h-8 ${isOpen ? 'tw-bg-zinc-300' : 'tw-bg-white hover:tw-bg-zinc-100'
                } tw-rounded tw-inline-flex tw-justify-center tw-items-center tw-gap-1.5`}
            onClick={onToggle}
            disabled={disabled}
            aria-haspopup="true"
            aria-expanded={isOpen}
        >
            {icon}
            <div className="tw-text-blue-950 tw-text-sm tw-leading-tight">
                {label}
            </div>
        </button>)
}

export default MenuButton
